import { useNavigate } from 'react-router-dom';

import { JudgeConfigForm } from '@/components/judge-configs/JudgeConfigForm';

export default function CreateJudgeConfigPage() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-text">Create Judge Config</h1>
        <p className="text-text-light mt-1">
          Configure a new LLM-as-a-judge with custom prompts and model settings
        </p>
      </div>

      <JudgeConfigForm
        onSuccess={() => navigate('/judge-configs')}
        onCancel={() => navigate('/judge-configs')}
      />
    </div>
  );
}
